import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["dsf_name", "dsf_role", "dsf_mobile"]
const _hoisted_2 = ["dsf_title"]
const _hoisted_3 = ["dsf_title", "dsf_selected", "dsf_id"]
const _hoisted_4 = ["dsf_title"]

import { computed } from 'vue'
import { languages } from '@/services/i18n'
import {
  afterTranslationChanged,
  translationProvider,
} from '@/services/translationProvider'
import { isLocalEnv } from '@/common/config'
import { logout } from '@/store/logoutActions'
import { getStateData } from '@/store'
import { analytics } from '@/services/analyticsProvider'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMenu',
  props: {
  mobileMode: Boolean,
},
  emits: ['select-language'],
  setup(__props, { emit }) {





const userName = computed(() => getStateData().profile?.name || '')
const companyName = computed(() => getStateData().company?.companyName || '')

const availableLanguages = computed(() => {
  if (isLocalEnv()) {
    return [...languages, { key: 'Untranslated', value: 'untranslated' }]
  }
  return languages
})

async function onLanguageChange(event: CustomEvent<string>) {
  event.stopPropagation()
  const { detail } = event

  await translationProvider.set(detail, {
    updated: (lang) => {
      if (isLocalEnv() && lang === 'untranslated') {
        afterTranslationChanged(lang, {})
      }
    },
  })
  emit('select-language')
}

async function onLogout(event: CustomEvent) {
  event.stopPropagation()
  await logout()
}

function handleOpenMenu({ detail: open }: CustomEvent<boolean>) {
  if (open) {
    analytics.trackShellEvent('click/icon-profile')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-nav-menu", {
    dsf_name: userName.value,
    dsf_role: companyName.value,
    dsf_mobile: __props.mobileMode,
    onOpenChanged: handleOpenMenu
  }, [
    _createCommentVNode(" Language selector "),
    _createElementVNode("dsf-navbar-item", {
      dsf_light: "",
      dsf_icon: "Globe",
      dsf_title: _ctx.$t('profile.language'),
      dsf_id: "language",
      onNavigate: onLanguageChange,
      onExpand: _cache[1] || (_cache[1] = ($event: any) => (_unref(analytics).trackShellEvent('click/menu-profile-language')))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableLanguages.value, (item) => {
        return (_openBlock(), _createElementBlock("dsf-navbar-item", {
          key: item.key,
          dsf_title: _ctx.$t(item.key),
          dsf_selected: item.value === _unref(translationProvider).currentLanguage,
          dsf_id: item.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(analytics).trackShellEvent('click/menu-profile-language-select')))
        }, null, 8 /* PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2),
    _createCommentVNode(" Logout "),
    _createElementVNode("dsf-navbar-item", {
      dsf_light: "",
      dsf_icon: "LogOut",
      dsf_title: _ctx.$t('profile.logout'),
      dsf_id: "logout",
      onNavigate: onLogout
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}
}

})